import { TWidgetPlan } from '@entities/widget-shop/model/types';

export const getCurrentPaymentPeriodInfo = ({
    widgetPlans,
    activePeriodPicked,
}: {
    widgetPlans: TWidgetPlan[];
    activePeriodPicked: TWidgetPlan['id'];
}) => widgetPlans?.find((period) => period.id === activePeriodPicked);
